export default {
	"route.dashboard": "Affichage des données",
	"route.robot": "Robot",
	"route.robotList": "Liste du robot",
	"route.groupManage": "Gestion du groupe",
	"route.disinfect": "Tâche",
	"route.home": "Accueil",
	"route.disinfectTask": "Tâche",
	"route.building": "Bâtiment",
	"route.accessControl": "Contrôle d'accès",
	"route.ladderControl": "Contrôle d'ascenseur",
	"route.IOT": "IOT",
	"route.accounts": "Compte",
	"route.roles": "Rôle",
	"route.jurisdiction": "Permission",
	"route.dispatcher": "Répartiteur de tâches",
	"navbar.logOut": "Se déconnecter",
	"login.title": "Connexion à l'identifiant d'entreprise",
	"login.logIn": "Se connecter",
	"login.username": "Nom d'utilisateur",
	"login.tip_username": "Veuillez saisir le numéro de compte",
	"login.password": "Mot de passe",
	"login.company_id": "Identifiant d'entreprise",
	"login.tip_company": "Veuillez entrer le compte d'entreprise",
	"login.tip_pwd": "Veuillez saisir le mot de passe",
	"robot.projectTtitle": "Plateforme de gestion du robot",
	"robot.manage": "Gestion du robot",
	"system.search": "Recherche",
	"system.reset": "Réinitialiser",
	"system.open": "Déplier",
	"system.retract": "Plier",
	"system.status": "Statut",
	"system.inProgress": "En cours",
	"system.normalCompletion": "Terminé",
	"system.abnormalEnd": "Fin anormale",
	"system.noData": "Pas de données",
	"universality.confirm": "Confirmer",
	"universality.cancel": "Annuler",
	"universality.Pleasedonot": "Veuillez ne pas entrer en blanc",
	"universality.Pleaseifsymbols": "Veuillez saisir 6 à 20 chiffres, anglais, symboles spéciaux",
	"disinfect.robotremarkname": "Remarque du robot",
	"disinfect.EnterNoteName": "Saisir la remarque",
	"disinfect.robotSerialNumber": "Numéro de série du robot",
	"disinfect.inputSequenceNumber": "Saisir le numéro de série",
	"disinfect.selectStatus": "Sélectionner le statut",
	"disinfect.destination": "Destination",
	"disinfect.Enterdestination": "Saisir la destination",
	"disinfect.dates": "Date",
	"disinfect.tos": "Jusqu'à",
	"disinfect.startDates": "Date de début",
	"disinfect.endDates": "Date de fin",
	"disinfect.starttimes": "Heure de début",
	"disinfect.endtimes": "Heure de fin",
	"disinfect.Lastweek": "Dernière semaine",
	"disinfect.Lastmonth": "Dernier mois",
	"disinfect.Lastthreemonths": "Trois derniers mois",
	"disinfect.nonExecution": "Non exécuté",
	"disinfect.canceled": "Annuler",
	"disinfect.UnclaimedProperty": "Personne ne ramasse les repas",
	"disinfect.hardwareFailure": "Défaillance matérielle",
	"disinfect.NavigationFault": "Défaillance de la navigation",
	"disinfect.Manualcancellation": "Annulation manuelle",
	"navigationBar.logout": "Se déconnecter",
	"navigationBar.logoutandsystem": "Se déconnecter du compte et du système?",
	"account.userlist": "Liste des utilisateurs",
	"account.searchnames": "Rechercher le compte et le nom",
	"account.adduser": "Ajouter un utilisateur",
	"account.user": "Utilisateur",
	"account.roles": "Rôle",
	"account.ResponsibleRobot": "Robot en charge",
	"account.name": "Nom",
	"account.remark": "Remarque",
	"account.Recentloginiof": "Dernière information de connexion",
	"account.operation": "Opération",
	"account.compile": "Éditer",
	"account.resetpasswords": "Réinitialiser le mot de passe",
	"account.delete": "Supprimer",
	"account.pleaseuserpasnumb": "6-20 lettres anglaises, chiffres, caractères spéciaux",
	"account.pleasepasswordnumb": "Veuillez saisir le mot de passe (6-20 lettres anglaises, chiffres, caractères spéciaux)",
	"account.selectroles": "Sélectionner le rôle",
	"account.selectbuild": "Sélectionner le bâtiment",
	"account.inputnames": "Veuillez saisir le nom d'utilisateur",
	"account.inputremarks": "Veuillez saisir les remarques",
	"account.userdetail": "Détails de l'utilisateur",
	"account.platform": "Unité",
	"account.noBindingRobot": "Pas de robot",
	"account.addtimes": "Heure d'ajout",
	"account.LastonlineTime": "Heure de dernière connexion",
	"account.Resetsuccessfully": "Réinitialisation réussie",
	"account.initialPassword": "Mot de passe original",
	"account.gotIt": "Je l'ai obtenu",
	"account.PleaseRoles": "Veuillez sélectionner le rôle",
	"account.Pleasebuilds": "Veuillez sélectionner le bâtiment",
	"account.PleaseRobots": "Veuillez sélectionner le robot",
	"account.compileusers": "Modifier le compte",
	"account.deleteusers": "Supprimer le compte",
	"account.Unabletologinafterdeleting": "Impossible de se connecter après avoir supprimé le compte, veuillez confirmer",
	"account.alreadyexistsConfirmpasswords": "Réinitialiser le mot de passe au mot de passe original ?",
	"account.alreadyExists": "Le compte existe déjà",
	"map.deleteThecloudmap": "La suppression de la carte cloud entraînera la suppression simultanée de toutes les cartes associées au robot. Êtes-vous sûr de vouloir supprimer ?",
	"map.deletemaps": "Supprimer la carte",
	"homes.robotTotal": "Nombre total de robots (unités)",
	"homes.tasksTotal": "Nombre total de tâches cumulées",
	"homes.onlineTimeTotal": "Temps en ligne cumulé",
	"homes.nearly-7-days-onlineTime": "Tendance du temps de connexion au cours des 7 derniers jours",
	"homes.cumulativeMileage": "Kilométrage cumulé (mètres)",
	"homes.robotWorkingHoursData": "Données relatives aux heures de travail du robot",
	"homes.trendWorkingHours": "Tendance des heures de travail",
	"homes.explain": "Remarques",
	"homes.explainContent": "Données de livraison du robot dans différents bâtiments",
	"homes.to": "À",
	"homes.startTime": "Heure de début",
	"homes.endTime": "Heure de fin",
	"homes.proportionWorkingHours": "Proportion des heures de travail",
	"homes.buildingDeliveryList": "Classement des livraisons de bâtiments",
	"public.second": "Fois",
	"public.rice": "Mètre",
	"public.lastSevenDays": "7 derniers jours",
	"public.lastFourteenDays": "14 derniers jours",
	"public.lastThirtyDays": "30 derniers jours",
	"robotState.notActive": "Non activé",
	"robotState.abnormalEnd": "Fin anormale",
	"robotState.hasLeft": "A quitté",
	"robotState.online": "En ligne",
	"robotState.offline": "Hors ligne",
	"robotState.charge": "Charge",
	"robotState.unknown": "Inconnu",
	"robotState.atWork": "Au travail",
	"robotState.free": "Libre",
	"robotState.unexecuted": "Non exécuté",
	"robotState.executing": "En cours d'exécution",
	"robotState.canceled": "Annulé",
	"robotState.Completed": "Terminé",
	"robotState.nobodyTakesThings": "Personne ne ramasse les repas",
	"robot.robotList": "Liste du robot",
	"robot.buildings": "Bâtiment",
	"robot.selectBuilding": "Sélectionner le bâtiment",
	"robot.search": "Rechercher la remarque et le numéro de série",
	"robot.notAddRobot": "Aucun robot ajouté ou activé",
	"robot.mileage": "Kilométrage cumulé",
	"robot.information": "Information de base",
	"robot.noteName": "Remarque",
	"robot.model": "Modèle",
	"robot.onlineStatus": "Statut en ligne",
	"robot.workingStatus": "Statut de travail",
	"robot.currentPower": "Puissance actuelle",
	"robot.serialNumber": "Numéro de série",
	"robot.operationData": "Données d'opération",
	"robot.latestOnlineTime": "Dernier temps de connexion",
	"robot.cumulativeOnlineDuration": "Temps en ligne cumulé",
	"robot.cumulativeDeliveryTimes": "Nombre cumulé de livraisons",
	"robot.cumulative-delivery-time": "Temps de livraison cumulé",
	"robot.cumulativeLeadTimes": "Nombre d'escorte cumulé",
	"robot.cumulativeLeadTime": "Temps d'escorte cumulé",
	"robot.System-Hardware": "Système et matériel",
	"robot.systemVersion": "Version du système",
	"robot.hardwareStatus": "État du matériel",
	"robot.language": "Langue du système",
	"robot.voice_pack": "Pack vocal",
	"robot.box_model": "Casier",
	"robot.android_soft": "Logiciel Android",
	"robot.android_mirror": "Android Mémoire Morte",
	"robot.header_control": "Panneau de commande de tête",
	"robot.under_panel_version": "Version du châssis",
	"robot.under_mirror": "Mise en miroir du châssis",
	"robot.under_master": "Commande principale du châssis",
	"robot.under_control": "Panneau de commande du châssis",
	"robot.rgbd_up": "RGBD(up)",
	"robot.rgbd_down": "RGBD(bas)",
	"robot.doorControlMotor": "Moteur de contrôle de porte",
	"robot.frontMountedCamera": "Caméra frontale",
	"robot.overheadCamera": "Caméra supérieure",
	"robot.infraredDetectionBox": "Détection infrarouge",
	"robot.microphone": "Microphone",
	"robot.radar": "Lidar",
	"robot.head-RGBD": "Tête RGBD",
	"robot.bottom-RGBD": "Bas RGBD",
	"robot.ultrasonicSensor": "Capteur ultrasonique",
	"robot.IMU": "IMU",
	"robot.hubMotor": "Moteur du moyeu",
	"robot.emergencyStopSwitch": "Bouton d'arrêt d'urgence",
	"robot.horn": "Haut-parleur",
	"robot.getFailed": "Echec de l'acquisition",
	"robot.normal": "Normal",
	"robot.abnormal": "Anormal",
	"robot.cancel": "Annuler",
	"robot.confirm": "Confirmer",
	"public.noteNameCannotBeEmpty": "La remarque ne peut pas être vide",
	"public.layer": "Étage",
	"public.door": "Bâtiment",
	"public.rename": "Renommer",
	"public.delete": "Supprimer",
	"robot.percentageTasksCompletedTotal": "Le pourcentage de tâches cumulées achevées",
	"robotState.workSuspension": "Tâche suspendue",
	"buiding.buildingList": "Liste des bâtiments",
	"buiding.add": "Ajouter",
	"buiding.addFloors": "Ajouter un étage",
	"buiding.pleaseCompleteBuidingsData": "Veuillez compléter les données du bâtiment dans la liste de gauche !",
	"buiding.map": "Carte",
	"buiding.source": "Source",
	"buiding.uploadTime": "Temps de téléchargement",
	"buiding.pleaseRobotUploadMap": "Veuillez télécharger la carte sur le robot",
	"buiding.associatedBuildings": "Bâtiments associés",
	"buiding.robot": "Robot",
	"buiding.associatedRobot": "Robots associés",
	"buiding.associatedShop": "Magasins associés",
	"buiding.type": "Type",
	"buiding.pleaseType": "Veuillez sélectionner le type",
	"buiding.buildingName": "Nom du bâtiment",
	"buiding.pleaseBuildingName": "Veuillez entrer le nom du bâtiment",
	"buiding.shopName": "Nom du magasin",
	"buiding.pleaseShopName": "Veuillez saisir le nom du magasin",
	"buiding.floor": "Etage",
	"buiding.floorName": "Nom de l'étage",
	"buiding.pleaseFloorName": "Nom de l'étage",
	"buiding.floorNameBeEmpty": "Le nom de l'étage ne peut pas être vide",
	"buiding.buid": "Bâtiment",
	"buiding.shop": "Magasin",
	"buiding.serialNumberCannotBeEmpty": "Le numéro de série ne peut pas être vide",
	"buiding.buildingAdd": "Ajouter un bâtiment",
	"buiding.pleaseBuilsdingName": "Veuillez ajouter le nom du bâtiment",
	"buiding.buildingsNameBeEmpty": "Le nom du bâtiment ne peut pas être vide",
	"buiding.AreYouSureToDeleteThisFloor": "Etes-vous sûr de vouloir supprimer l'étage ?",
	"buiding.deleteFloor": "Supprimer l'étage",
	"buiding.AreYouSureToDeleteThisShop": "Êtes-vous sûr de vouloir supprimer le magasin ?",
	"buiding.deleteShop": "Supprimer le magasin",
	"buiding.AreYouSureToDeleteThisBuilding": "Etes-vous sûr de vouloir supprimer le bâtiment ?",
	"buiding.deleteBuilding": "Supprimer le bâtiment",
	"buiding.editBuilding": "Modifier le bâtiment",
	"buiding.editFloor": "Modifier l'étage",
	"buiding.editShop": "Modifier le magasin",
	"buiding.shopNameAlreadyExists": "Le nom du magasin existe déjà",
	"buiding.shopAddSuccess": "Le magasin est ajouté avec succès",
	"buiding.floorNameAlreadyExists": "Le nom de l'étage existe déjà",
	"buiding.floorAddSuccess": "L'étage est ajouté avec succès",
	"buiding.buildingNameAlreadyExists": "Le nom du bâtiment existe déjà",
	"buiding.buildingAddSuccess": "Le bâtiment est ajouté avec succès",
	"buiding.shopEditSuccess": "Le magasin est modifié avec succès",
	"buiding.buildingEditSuccess": "Le bâtiment est modifié avec succès",
	"buiding.floorEditSuccess": "L'étage est modifié avec succès",
	"buiding.selectRobot": "Sélectionner un robot",
	"buiding.replacementBuildings": "Changer de bâtiment",
	"role.rolelist": "Liste des rôles",
	"role.addroles": "Ajouter un rôle",
	"role.names": "Nom",
	"role.Entername": "Taper un nom",
	"role.PleaseEntername": "Veuillez taper un nom",
	"role.editroles": "Modifier le rôle",
	"role.deleteroles": "Supprimer le rôle",
	"role.Confirmdeletion": "Êtes-vous sûr de vouloir supprimer le rôle ? Vous ne pouvez pas annuler cette action.",
	"role.nameAlreadyExists": "Le nom du rôle existe déjà",
	"navigationBar.personalInfo": "Informations personnelles",
	"navigationBar.changePassword": "Modifier le mot de passe",
	"navigationBar.administrator": "Administrateur",
	"navigationBar.domesticConsumer": "Utilisateur général",
	"navigationBar.originalPsd": "Mot de passe original",
	"navigationBar.EnterOriginalPsd": "Saisir le mot de passe d'origine",
	"navigationBar.newPassword": "Nouveau mot de passe",
	"navigationBar.confirmPassword": "Confirmer le mot de passe",
	"navigationBar.EntertheNewPsdAga": "Saisissez à nouveau le nouveau mot de passe",
	"navigationBar.TheOriPsdCannotEmpty": "Le mot de passe original ne peut pas être vide",
	"navigationBar.TheNewPsdempty": "Le nouveau mot de passe ne peut pas être vide",
	"navigationBar.PleEntertheNewPsdAga": "Veuillez saisir à nouveau le nouveau mot de passe",
	"navigationBar.TheNewPasastheoldone": "Le nouveau mot de passe est le même que l'ancien",
	"navigationBar.Psdisinconsistentwith": "Les deux mots de passe sont différents. Veuillez confirmer.",
	"navigationBar.modifySuccessfully": "Modifié avec succès",
	"accessControl.accessControlList": "Liste de contrôle d'accès",
	"accessControl.floor": "Étage",
	"accessControl.accessControlAdd": "Ajouter le contrôle d'accès",
	"accessControl.accessControlID": "ID du contrôle d'accès",
	"accessControl.selectAccessControlID": "Sélectionner l'ID de contrôle d'accès",
	"accessControl.accessControlID-Hint": "Le service de contrôle d'accès est confirmé. Le client a déjà configuré l'ID de contrôle d'accès.",
	"accessControl.label": "Remarque",
	"accessControl.pleaseLabel": "Saisir la remarque",
	"accessControl.deleteAccessControl-Hint": "La suppression du contrôle d'accès rend le robot incapable d'effectuer des tâches de porte croisées automatiques. Êtes-vous sûr de vouloir le supprimer?",
	"accessControl.deleteAccessControl": "Supprimer le contrôle d'accès",
	"accessControl.editAccessControl": "Modifier le contrôle d'accès",
	"accessControl.accessControlIdExists": "L'ID du contrôle d'accès existe déjà",
	"public.notAssociatedFloor": "Non associé à l'étage",
	"public.notAssociatedBuilding": "Non associé au bâtiment",
	"public.all": "Tout",
	"public.rules.pleaseLabel": "Veuillez saisir la remarque",
	"dispatcher.dispatcherList": "Liste des répartiteurs de tâches",
	"dispatcher.searchName": "Rechercher le nom",
	"buiding.deleteShopTips": "Veuillez d'abord déconnecter toutes les données (robots/cartes) du magasin",
	"buiding.deleteBuidingTips": "Veuillez d'abord déconnecter toutes les données (robots/cartes) du bâtiment",
	"buiding.deleteFloorTips": "Veuillez d'abord déconnecter toutes les données (cartes) de l'étage",
	"ladderControl.ladderControlList": "Liste du contrôle d'ascenseur",
	"ladderControl.addLadderControl": "Ajouter un contrôle d'ascenseur",
	"ladderControl.grouping": "Groupe",
	"ladderControl.Buildings": "Bâtiment",
	"ladderControl.You-can-go-to-the-floor": "Étages accessibles",
	"ladderControl.pleaseGoToBuilding": "Veuillez vous rendre au bâtiment et accéder au contrôle d'ascenseur",
	"ladderControl.grouping-tips-1": "Le groupement est principalement utilisé pour distinguer différents points d'appel",
	"ladderControl.grouping-tips-2": "1. Dans le cas d'un seul ascenseur ou de plusieurs ascenseurs au même étage, vous pouvez sélectionner le groupe par défaut.",
	"ladderControl.grouping-tips-3": "2. Les ascenseurs à différents étages et les différentes salles d'attente doivent être divisés en groupes.",
	"public.common": "Bâtiment",
	"ladderControl.ladderControlID": "ID de contrôle de l'ascenseur",
	"ladderControl.selectLadderControlID": "Sélectionner l'ID de contrôle de l'ascenseur",
	"ladderControl.ladderControlID-tips": "Veuillez vérifier auprès du service de contrôle des ascenseurs/contrôle d'accès que le client a déjà configuré l'ID de contrôle de l'ascenseur.",
	"ladderControl.groupingPlaceholder": "Saisir ou sélectionner un groupe (par exemple : ascenseurs de grande hauteur)",
	"ladderControl.deleteladderControl": "Supprimer le contrôle d'ascenseur",
	"ladderControl.deleteladderControl-tips": "Si vous supprimez le contrôle d'ascenseur, le robot ne pourra plus effectuer de tâches d'un étage à l'autre. Êtes-vous sûr de vouloir le supprimer ?",
	"ladderControl.ladderControlIdExists": "L'ID du contrôle d'ascenseur existe déjà",
	"login.remTheNub": "Mémoriser le mot de passe",
	"login.oldPasswordError": "Le mot de passe d’origine est incorrect",
	"login.confirmAndNewParrword": "Les deux mots de passe sont différents",
	"robot.advertising": "Annonces publicitaires",
	"homes.buildingDeliveryTimes": "Nombre de livraisons",
	"robot.detail": "Détails du robot",
	"robot.robotModel": "Type de robot",
	"robot.header_control-2": "Carte d'alimentation Android",
	"robot.under_mirror-2": "Mise en miroir du châssis",
	"robot.under_master-2": "Commande principale du châssis",
	"robot.under_control-2": "Carte d'alimentation du châssis",
	"robot.nav": "Algorithme de navigation",
	"robot.up_rgbd": "RGBD supérieur",
	"robot.down_rgbd": "RGBD inférieur",
	"robot.camera": "Caméra supérieure",
	"robot.ss": "Caméra frontale",
	"robot.rgbd_top_depth": "Profondeur RGBD supérieure",
	"robot.rgbd_top_color": "Couleur RGBD supérieure",
	"robot.rgbd_bottom_depth": "Profondeur RGBD inférieure",
	"robot.rgbd_bottom_color": "Couleur RGBD inférieure",
	"robot.ultrasonic1": "Échographie gauche",
	"robot.ultrasonic2": "Échographie droite",
	"robot.motor1": "Moteur gauche",
	"robot.motor2": "Moteur droit",
	"robot.detection": "Détection d'objets",
	"buiding.builNameAlreadyExists": "Le nom du bâtiment existe déjà",
	"robot.bindingSuccess": "Liaison réussie",
	"robot.notActive": "Non activé",
	"robotinfo.logdown": "Téléchargement du journal",
	"robotinfo.Logtype": "Type de journal",
	"robotinfo.displayboard": "Tableau d'affichage",
	"robotinfo.maincontrolpanel": "Tableau de commande principal",
	"robotinfo.powerstrip": "Tableau d'alimentation",
	"robotinfo.navigationdata": "Données de navigation",
	"robotinfo.Plethedate": "Veuillez sélectionner une date",
	"robotinfo.Plethetime": "Veuillez sélectionner une heure",
	"robotinfo.acquire": "Télécharger",
	"robotinfo.Packinglog": "Emballage des journaux",
	"robotinfo.Uploadinglogfiles": "Téléchargement du fichier journal",
	"robotinfo.Gettinguploadstatus": "Obtenir l'état du téléchargement",
	"robotinfo.acquiresuccess": "Acquisition réussie",
	"robotinfo.clicktodownload": "Cliquez pour télécharger",
	"robotinfo.Plelogtype": "Veuillez sélectionner un type de journal",
	"robotinfo.Plestartdateandtime": "Veuillez sélectionner une date et une heure de début",
	"robotinfo.Pleanenddateandtime": "Veuillez sélectionner une date et une heure de fin",
	"robotinfo.Nologtime": "Pas de journal pour cette période",
	"robotinfo.logtaskispackagedpackged": "Le robot est en train d'emballer ou de télécharger des journaux.",
	"robotinfo.failtoget": "Échec de la réception",
	"robotinfo.Failedtopackage1/2": "Échec de l'emballage 1/2",
	"robotinfo.Failedtopackage2/2": "Échec de l'emballage 2/2",
	"robotinfo.failtoupload": "Échec du téléchargement",
	"public.unrelatedBuildings": "Non associé au bâtiment",
	"buiding.sameFloorNumber": "Le même numéro d'étage existe déjà dans ce bâtiment",
	"navigationBar.pleaseEnterOriginalPsd": "Veuillez saisir le mot de passe original",
	"navigationBar.newpassword": "Entrez un nouveau mot de passe (6-20 chiffres, anglais, symboles)",
	"navigationBar.pleaseNewpassword": "Veuillez saisir un nouveau mot de passe",
	"login.nnterprise-number-error": "Erreur d'identification de l'entreprise",
	"home.Fullrobot": "Tous les robots",
	"map.displaytext": "Afficher le texte",
	"map.nonetext": "Ne pas afficher le texte",
	"robot.detection-1": "Détection d'objets 1",
	"robot.detection-2": "Détection d'objets 2",
	"robot.detection-3": "Détection d'objets 3",
	"robot.detection-4": "Détection d'objets 4",
	"robot.current_systemVersion": "Version actuelle",
	"robot.cumulativeTimes": "Délais de livraison cumulés",
	"robot.cumulativeTime": "Délai de livraison cumulé",
	"home.hour": "h",
	"home.min": "min",
	"home.deliverytimes": "Délais de livraison (heures)",
	"login.actpaswdinco": "Nom d'utilisateur ou mot de passe incorrect",
	"login.enterpriseerror": "Erreur d'identification de l'entreprise",
	"home.numberofworkmachs": "Nombre de robots en activité",
	"home.workinghours": "Heures de travail",
	"login.account_expired": "Le compte a expiré. Veuillez vous reconnecter",
	"robot.CADEBOT_rankingList_tips": "Classement des délais de livraison à destination",
	"robot.setLabel": "La remarque a été réglée avec succès",
	"homes.nearly-7-days-mileage": "Évolution du kilométrage au cours des 7 derniers jours",
	"robot.robotisofflineobtalogs": "Les journaux ne sont pas disponibles car le robot est hors ligne.",
	"buiding.buid-illustrate": "Bâtiment (pour plusieurs étages)",
	"buiding.shop-illustrate": "Magasin (pour un étage)",
	"buiding.new-pleaseFloorName": "Veuillez saisir le nom de l'étage",
	"route.admage": "Annonces",
	"route.asset": "Bibliothèque de ressources",
	"route.ads": "Publication de l'annonce",
	"route.adsDetail": "Détails de l'annonce",
	"route.addAds": "Ajouter une annonce",
	"route.editAds": "Modifier les annonces",
	"ad.asset": "Liste des ressources",
	"ad.freeSpace": "Espace restant",
	"ad.uploadAsset": "Télécharger les ressources",
	"ad.filename": "Nom du fichier",
	"ad.type": "Type de fichier",
	"ad.memory": "Mémoire",
	"ad.video": "Vidéo",
	"ad.image": "Image",
	"ad.uploadTime": "Temps de téléchargement",
	"ad.uploadProgress": "Progression du téléchargement",
	"ad.uploadSuccess": "Téléchargement réussi",
	"ad.operation": "Opération",
	"ad.check": "Affichage",
	"ad.delete": "Supprimer",
	"ad.confirm": "Confirmer",
	"ad.cancel": "Annuler",
	"ad.deleteSuccess": "Supprimé avec succès",
	"ad.back": "Retour",
	"ad.deleteAsset": "Suppression de ressources",
	"ad.deleteAssetWarningMessage": "Les ressources supprimées ne seront pas récupérées, confirmer la suppression ?",
	"ad.extLimit": "Seuls les fichiers aux formats JPG, PNG, MP4, AVI, MOV, WMV, RMVB peuvent être téléchargés.",
	"ad.sizeLimit": "Un seul fichier ne peut pas dépasser 1 Go.",
	"ad.syncFail": "Échec du téléchargement",
	"ad.syncComplete": "Téléchargement terminé",
	"ad.downloadComplete": "Configuration en cours",
	"ad.downloadWaiting": "Non téléchargé",
	"ad.name": "Nom du fichier",
	"ad.playTime": "Durée de lecture",
	"ad.materialNum": "Nombre de ressources",
	"ad.robotNum": "Nombre de robots",
	"ad.startTime": "Temps de publication",
	"ad.addSchema": "Ajouter une annonce",
	"ad.copySchema": "Copier le plan",
	"ad.edit": "Editer",
	"ad.publish": "Publier",
	"ad.deleteDraft": "Supprimer le plan",
	"ad.save": "Sauvegarder",
	"ad.preview": "Aperçu",
	"ad.setDefault": "Utiliser maintenant",
	"ad.setDefaultPlease": "Veuillez définir la valeur par défaut",
	"ad.yes": "Oui",
	"ad.no": "Non",
	"ad.deleteDraftWarningMessage": "Confirmer la suppression du programme ?",
	"ad.draft": "Non publié",
	"ad.schemaDetail": "Détails du plan",
	"ad.schemaContent": "Contenu du plan",
	"ad.syncRecord": "Enregistrement synchronisé",
	"ad.robotSn": "Abandon des robots",
	"ad.robotSelect": "Sélectionner un robot",
	"ad.nameInput": "Entrez le nom du plan",
	"ad.robotSelectPlease": "Veuillez sélectionner un robot",
	"ad.nameInputPlease": "Veuillez saisir un nom de plan",
	"ad.materialList": "Liste des ressources",
	"ad.materialListDescriptions": "Dimension de l'écran publicitaire : 1080*1920. Faites glisser le cadre du matériau pour ajuster l'ordre.",
	"ad.setting": "Paramètres de placement",
	"ad.period": "Période de temps",
	"ad.allDay": "Tous les jours",
	"ad.someTime": "Période de temps",
	"ad.beginTime": "Heure de début",
	"ad.endTime": "Heure de fin",
	"ad.materialLib": "Bibliothèque de ressources",
	"ad.materialNumber": "Nombre de ressources",
	"ad.removeScreen": "Supprimer l'écran partagé",
	"ad.removeScreenConfirm": "Confirmer la suppression de l'écran partagé ?",
	"ad.playTimeDuration": "Durée de la lecture",
	"ad.picturePlayTime": "Durée de lecture de l'image",
	"ad.addPeriod": "Ajouter une plage horaire",
	"ad.addPeriodLimit": "Vous pouvez ajouter 6 plages horaires différentes",
	"ad.totalTime": "Durée totale",
	"ad.saveSuccess": "Sauvegarder avec succès",
	"ad.publishSuccess": "Publier avec succès",
	"ad.addPeriodFail": "J'ai déjà une plage horaire d'une journée entière, je ne peux pas l'ajouter.",
	"ad.publishFail": "Échec de la publication",
	"ad.playTimeNoEmpty": "Le temps de jeu ne peut pas être vide",
	"ad.materialListNoEmpty": "L'écran partagé ne peut pas être laissé vide",
	"ad.robot": "Robot",
	"ad.robotOffline": "Robot hors ligne",
	"ad.robotOfflineAndCanNotLaunch": "Les robots suivants sont hors ligne et ne peuvent pas être placés",
	"ad.robotUplineOrSaveDraft": "Veuillez faire fonctionner le robot en ligne ou enregistrer d'abord le plan en tant que brouillon.",
	"ad.syncStatus": "État du téléchargement du robot",
	"ad.reSync": "Republier",
	"ad.goBackList": "Retour à la liste",
	"ad.confirmPublish": "Êtes-vous sûr de vouloir publier ?",
	"ad.robotOfflineToConfirmPublish": "Le robot suivant est hors ligne, pouvez-vous confirmer la publication ?",
	"ad.addCancelConfirm": "Voulez-vous confirmer que le contenu actuel n'est pas sauvegardé après le retour ?",
	"ad.refresh": "Actualiser",
	"ad.publishTime": "Heure de publication",
	"ad.lastModifyTime": "Heure de la dernière modification",
	"ad.publisher": "Publié par",
	"ad.editor": "Modifié par",
	"ad.timeOverlap": "Les périodes de lecture ne peuvent pas se chevaucher, veuillez vérifier",
	"ad.endTimeMustLargerThanStartTime": "L'heure de fin de la période de lecture doit être supérieure à l'heure de début.",
	"ad.cannotDeleteAssetUsed": "Ce clip a été référencé et ne peut être supprimé.",
	"ad.deletePeriodWarningMessage": "Souhaitez-vous confirmer la suppression des plages horaires ?",
	"ad.complete": "Oui, c'est fait",
	"ad.fail": "Échec",
	"ad.nameInputIllegal": "Le nom du plan ne peut pas contenir de caractères spéciaux",
	"ad.nameDuplicate": "Le nom du plan existe déjà",
	"ad.updateTime": "Dernière heure de modification",
	"role.TherolesDeletingfails": "Le rôle est lié à un compte, la suppression a échoué",
	"account.Changeofauthority": "Changement de permission",
	"account.ThepermisschgePleaseagain": "La permission de ce compte a été modifiée",
	"disinfect.Unknowncause": "Aucune raison connue",
	"robot.accumulatedTaskExecutionTimes": "Nombre cumulé de tâches effectuées",
	"home.minute": "minutes",
	"homes.Statisticstasks": "Statistiques du robot effectuant des tâches (travail en cours)",
	"disinfect.Initilizati": "Échec de l'initialisation",
	"disinfect.Failedtogetlocation": "Échec de l'obtention de la position",
	"disinfect.pointisoffthemap": "Le point cible est en dehors de la carte",
	"disinfect.onastaticobstacle": "Le point cible est sur un obstacle statique",
	"disinfect.therearenoroadsonthestaticmap": "Pas de chemin sur la carte statique",
	"disinfect.Startingpointobstacle": "Il y a un obstacle au départ",
	"disinfect.Lossoflocation": "Emplacement perdu",
	"disinfect.Failedtolocatethelostlocalpath": "Échec de la planification partielle de la trajectoire",
	"disinfect.Clifftriggercancellation": "Annulation du déclenchement de la falaise",
	"disinfect.Emergencystoptriggerscancellation": "Annulation du déclenchement de l'arrêt d'urgence",
	"disinfect.Collisionbartriggercancel": "Annulation du déclenchement de la bande anticollision",
	"disinfect.overtime": "Temps écoulé",
	"disinfect.Chargingpiledetectionfailed": "Échec de la détection du quai de chargement",
	"disinfect.Pilefailure": "Échec de l'empilage",
	"disinfect.GlobalpathplanningfailedProcedure": "Échec de la planification globale de la trajectoire",
	"disinfect.Slopetriggercancellation": "Annulation du déclenchement de la pente",
	"disinfect.NavigationrecoverybeProcedure": "Échec de la récupération de la navigation",
	"disinfect.Navigateoutnarrowchannel": "Le chemin étroit est bloqué",
	"disinfect.Androidtasktimeout": "Délai d'exécution de la tâche",
	"disinfect.elsesa": "autres erreurs",
	"robot.historicaldelete": "Les données historiques de ce robot seront supprimées, confirmez la suppression ?",
	"robot.delfaild": "La suppression a échoué",
	"robot.LoRa_ID": "ID LoRa",
	"robot.associatedSIMCard": "Carte SIM associée",
	"robot.accumulatedUsageTraffic": "Utilisation cumulée du trafic",
	"robot.trafficUsageMonth": "Utilisation mensuelle du trafic",
	"robot.newrgbd_bottom_depth": "Profondeur RGBD inférieure",
	"robot.batteryTest": "Détection de la batterie",
	"robot.Partial_information_update_failed": "Échec de la mise à jour de certaines informations",
	"robot.update_failed": "mise à jour a échoué",
	"robot.update_robot_datasSuccess": "Obtenez les dernières données du robot avec succès",
	"ad.waitForDownload": "en attente de téléchargement",
	"ad.startDownload": "Commencer Le Téléchargement",
	"ad.offLineAndCannotDownload": "Appareil hors ligne, impossible de télécharger",
	"ad.syncing": "synchronisation...",
	"robot.robot_does_not_exist": "le robot n'existe pas",
	"robot.robot_current_enterprise": "Les robots ont quitté l'entreprise actuelle",
	"ad.notEnoughSpace": "Il n'y a pas assez d'espace pour les documents d'entreprise, veuillez nettoyer les fichiers à temps",
	"ad.addAsset": "ajouter du matériel",
	"robot.batteryCommunication": "batterie communication",
	"disinfect.Thetargetpointisobstacle": "Le point cible est sur un obstacle dynamique",
	"disinfect.Therearenoroadsonadynamicmap": "Il n'y a pas de route sur la carte dynamique",
	"robot.buildingRobotErrorTips_10019": "Le nombre de robots dans ce magasin a atteint la limite supérieure de 16, veuillez changer le bâtiment (magasin)",
	"robot.buildingRobotErrorTips_10020": "Erreur lors de la génération de LoraId",
	"map.VirtualWall": "Mur virtuel",
	"map.Qrcode": "QR Code",
	"map.regions": "zone",
	"map.anchorpoints": "point de localisation",
	"robot.noSearchResults": "aucun résultat trouvé",
	"robot.accountInformationHasBeenModified": "Les informations du compte ont été modifiées",
	"public.tips": "indice",
	"public.agreeWith": "accepter",
	"public.iHaveReadAndAgree": "J'ai lu et accepté",
	"public.userAgreement": "Accord de l'utilisateur",
	"public.gentle": "et",
	"public.privacyAgreement": "politique de confidentialité",
	"public.pleaseAgreeFirst": "veuillez d'abord accepter",
}